import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import type { AnyApiFactory } from '@backstage/core-plugin-api';
import { clearAccessToken, getAccessToken } from './api/accessTokenStore';
import { InterceptedFetchApi } from './api/InterceptedFetchApi';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory({
    api: fetchApiRef,
    deps: {
      configApi: configApiRef,
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      errorApi: errorApiRef,
    },
    factory: ({ configApi, discoveryApi, identityApi, errorApi }) =>
      new InterceptedFetchApi({
        configApi,
        discoveryApi,
        identityApi,
        errorApi,
        getAccessToken,
        clearAccessToken,
      }),
  }),
];
